<template>
    <div class="successCases">
        <div class="successCases-title">
            <div class="title">
                <div class="title-text"><span>成功</span>案例</div>
                <div class="title-more"><span>SUCCESS</span><span>CASES</span></div>
            </div>
            <!-- <div class="title-des">打造数智竞争力 赋能智造新未来</div> -->
            <div class="cases">
                <a class="case-item" v-for="(item, index) in list" :key="index" @mouseenter="active(index)"
                    @click="gotoSuccess(index)" @mouseleave="startTime"
                    :class="{ 'case-item-active': index == activeIndex }">
                    <span>{{ item.title }}</span>
                    <img src="@/assets/images/index/case-left.png" alt="">
                </a>

            </div>
        </div>
        <div class="successCases-content">
            <div class="content-left">
                <img v-lazy="one" alt="" v-if="activeIndex == 0">
                <img v-lazy="two" alt="" v-if="activeIndex == 1">
                <img v-lazy="three" alt="" v-if="activeIndex == 2">
            </div>
            <div class="content-right">
                <h3 class="content-right-title">{{ list[activeIndex].title }}</h3>

                <div class="line">
                    <span></span>
                    <span></span>
                </div>
                <span class="content">{{ list[activeIndex].content }}</span>
                <div class="content-right-btn">
                    <button class="btn btn-one" @click="gotoSu()">
                        <img src="@/assets/images/index/case-left.png" alt="">
                        查看更多</button>
                    <button class="btn btn-two" @click="gotoSu('/my/contant-us')">
                        <img src="@/assets/images/index/case-phone.png" alt="">
                        联系我们</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import one from "@/assets/images/index/process-one.png"
import two from "@/assets/images/index/process-two.png"
import three from "@/assets/images/index/process-three.png"
import { useRouter } from 'vue-router'
const router = useRouter()
import { ref, onMounted, onUnmounted } from 'vue'
let time = ref(null)
onMounted(() => {
    startTime()
})
const startTime = () => {
    if (time.value) {
        clearInterval(time.value)
    }
    time.value = setInterval(() => {
        if (activeIndex.value == 2) {
            activeIndex.value = 0
            return
        }
        activeIndex.value = activeIndex.value + 1
    }, 5000)
}
onUnmounted(() => {
    clearInterval(time.value)
})
const gotoSuccess = (index) => {
    if (index == 3) {
        router.push({
            path: 'success-cases'
        })
    }
}
const gotoSu = (flag) => {
    if (flag) {
        router.push({
            path: flag
        })
        return
    }
    if (list.value[activeIndex.value].data) {
        router.push({
            path: 'success-cases/detail',
            query: {
                data: list.value[activeIndex.value].data
            }
        })
    }
}
const activeIndex = ref(0)
const active = (index) => {
    if (index == 3) {
        return
    }
    clearInterval(time.value)
    activeIndex.value = index
}
const list = ref([
    {
        data: '设备数据湖',
        title: "设备数字看板在制造业的成功案例",
        content: '设备数字看板项目广泛应用于多个行业，通过实时采集和分析设备产量、状态、能耗等数据，帮助企业实现自动化采集、数字化展示、能耗监控、生产效率提升以及运维优化等。设备数据湖为企业进行科学决策，降低运营成本，提高整体生产管理效率提供了高价值的数据要素支持。'
    },
    {
        data: '日本',
        title: "日本某塑料再生工厂智能化案例",
        content: '通过全球设备数字资产管理平台提升了生产效率和产品质量，降低了生产成本，减少了停机时间，提高了设备可用性。同时通过AI模型平台和数字孪生技术进一步优化生产工艺，提升产品质量，增强竞争力。'
    }, {
        data: "AI模型",
        title: "来金股份焊接质量管理AI模型应用案例",
        content: '通过AI焊接质量管理模型显著提升了焊点合格率，减少了生产线停机时间，降低了维护成本。通过实时监控和参数优化，实现了数据驱动的精益工艺管理，提升了生产效率和产品质量。'
    }, {
        title: "更多成功案例",
    }
])
</script>

<style lang="less" scoped>
.successCases {
    width: 100%;
    margin-top: 6.25rem;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
}

.successCases-title {
    border-bottom: 2px solid #E7E7E7;
    height: 13.125rem;
    text-align: left;
    position: relative;

    .title-des {
        font-size: 1.5rem;
        color: #999999;
    }

    .title {
        font-size: 3.125rem;
        font-weight: bold;
        position: relative;
        height: 8.75rem;

        .title-text {
            position: absolute;
            top: .5625rem;
            left: .25rem;


            span {
                &:nth-child(1) {
                    color: @xtxColor;
                }
            }
        }

        .title-more {
            font-size: 6.25rem;
            -webkit-text-stroke: 2px #3E3A39;
            opacity: 0.1;
            color: transparent; //字体颜色设置为透明
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .cases {
        width: 31.25rem;
        height: 8.75rem;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .case-item {
            margin-bottom: 20px;
            font-size: 1.5rem;
            color: #3E3A39;
            background: #F3F3F3;
            width: 15rem;
            height: 3.75rem;
            border-radius: .375rem;
            line-height: 3.75rem;
            padding-left: 1.75rem;
            position: relative;
            transition: all .5s;

            span {
                width: 70%;
                display: inline-block;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            &:hover {
                background: @xtxColor;
                color: #fff;

                img {
                    transform: rotate(90deg);
                }
            }

            img {
                width: .8125rem;
                height: 1.4375rem;
                position: absolute;
                margin-top: 1.125rem;
                right: 1.875rem;
                transition: all .5s;

            }
        }

        .case-item-active {

            background: @xtxColor;
            color: #fff;

            img {
                transform: rotate(90deg);
            }

        }
    }
}

.successCases-content {
    width: 100%;
    height: 31.25rem;
    margin-top: 3.75rem;
    display: flex;

    .content-left {
        width: 44.375rem;
        height: 100%;


        img {
            width: 100%;
            height: 100%;
        }
    }

    .content-right {
        flex: 1;

        padding-left: 5rem;
        padding-top: 2.875rem;
        text-align: left;
        position: relative;

        .content-right-title {
            font-size: 2.5rem;
            font-weight: bold;
            width: 100%;
        }

        .line {
            width: 100%;
            margin-top: 1.625rem;

            span {
                &:nth-child(1) {
                    width: 15rem;
                    height: .375rem;
                    display: inline-block;
                    background: @xtxColor;
                }

                &:nth-child(2) {
                    width: calc(100% - 15rem);
                    height: .125rem;
                    display: inline-block;
                    background: #EAEAEA;
                }
            }
        }

        .content {
            display: block;
            margin-top: 1.875rem;
            color: #3E3A39;
            font-size: 1.125rem;
            line-height: 2.1875rem;
        }

        .content-right-btn {
            position: absolute;
            bottom: 2.25rem;

            .btn {
                width: 11.25rem;
                height: 3.75rem;
                border-radius: 1.875rem;
                border: none;
                margin-right: 1.375rem;
                font-size: 1.25rem;
                color: #fff;
                transition: all .5s;
                cursor: pointer;
                padding-left: 2.25rem;

                &:hover {
                    transform: scale(1.1);
                }
            }

            .btn-one {
                background: @xtxColor;
                position: relative;

                img {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 2.5rem;
                    width: .6875rem;
                    height: 1.1875rem;
                }
            }

            .btn-two {
                background: #53A421;
                position: relative;

                img {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 2.25rem;
                    width: 1.25rem;
                    height: 1.375rem;
                }
            }
        }
    }
}
</style>